///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Pipe, PipeTransform } from '@angular/core';
import { NodeFeature } from '../../../../logical-topology/entities/node/node-feature';

@Pipe({
    name: 'filter',
    pure: true,
    standalone: false
})
export class GtthNameFilterPipe implements PipeTransform {
    transform(topologyNodes: NodeFeature[], searchText: string): NodeFeature[] {
        if (!topologyNodes) return [];
        if (!searchText) return topologyNodes;
        searchText = searchText.toLowerCase();
        return topologyNodes.filter((node: NodeFeature) => {
            return node.getName().toLowerCase().includes(searchText);
        });
    }
}
